import { Navigate } from 'react-router-dom';

export default function ProtectedProduct({ id, products, children }) {
  if (!products.includes(id)) {
    const fallback = products[0];
    const routes = { core: '/app/core', re_suite: '/app/re-suite' };
    return <Navigate to={routes[fallback] || '/'} replace />;
  }
  return children;
}
